/**
 * 管理文档标题高亮
 *
 * 1. 当用户尚未使用此功能时，需要红点提示
 * 2. 需要根据当前的文档是否高亮来决定 ui 样式
 */
import { Feature } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import SwitchManager from '@src/slide/infrastructure/module/dependent/config/switch-system';
import { SWITCH_KEY } from '@src/slide/infrastructure/module/dependent/config/switch-system/contant';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

@Feature()
export class TitleHighlightFeature {
    // 标题的高亮颜色，SVIP 才有值，不是 SVIP 的话就是 ''
    public titleColor: string;

    public constructor() {
        // 红点功能已下掉，置为 false 后不再变更
        userLocalStorage.setItem(LocalStorageKeys.SVIP_TITLE_COLOR_RED_DOT, { show: false });
        // data/get 接口还没有 personalizeInfo，先从 basicClientVars 获取
        // 之后可以从 sdk 的 docExtraInfoReady 事件获取
        this.titleColor = window.basicClientVars?.docInfo?.personalizeInfo?.titleColor?.color ?? '';
    }

    /**
     * 判断是否需要文档高亮的功能
     * @return {boolean}
     */
    public shouldHighlight(): boolean {
        // cac 配置关了
        if (!DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.highlightTitle)) {
            return false;
        }
        // shiply 开关关了
        if (!SwitchManager.getKeyValueFromMap(SWITCH_KEY.PPT_HIGHLIGHT_TITLE)) {
            return false;
        }
        // 不是所有者
        if (!SlideDataServices.DocInfoManager()?.isOwner) {
            return false;
        }
        return true;
    }

    /**
     * 当用户使用了高亮标题的功能时:
     * 修改标题颜色
     */
    public toggleTitleHighlight(color?: string): void {
        // 取消红点显示
        userLocalStorage.setItem(LocalStorageKeys.SVIP_TITLE_COLOR_RED_DOT, { show: false });
        if (color !== undefined) {
            this.titleColor = color;
        }
    }
}
